import {Component, effect, inject, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";
import {RightSearchByThaidComponent} from "../right-search/thaid/right-search-by-thaid.component"
import {RightSearchByIdCardComponent} from "../right-search/idcard/right-search-by-id-card.component";
import {RightSearchByPersonalIdComponent} from "../right-search/personal-id/right-search-by-personal-id.component";
import {RightSearchComponent} from "../right-search/right-search.component";
import {MenuStageService} from "../../../shared/commons/services/menu-stage.service";

@Component({
  selector: 'app-revoked',
  standalone: true,
  imports: [
    RouterLink,
    SharedCommonModule,
  ],
  templateUrl: './revoked.component.html',
  styleUrl: './revoked.component.scss'
})
export class RevokedComponent implements OnInit{
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  menuStageService = inject(MenuStageService);

  menu:string="revoke"
  ngOnInit(): void {
      this.menuStageService.setMenu("revoke");
      console.log("localstorage",this.menuStageService.getStoredMenu())
  }

}
